export function getSummaProps(summa: any, variant: string) {
  if (summa?.variants && summa.variants[variant]) {
    return summa.variants[variant];
  }
  return summa;
}
